export default "<div class=\"table4js__checkbox-editor\">\n  <input type=\"checkbox\" data-bind=\"checked: value\" />\n</div>";